// src/services/stockApi.js
// API para registrar stock asociado a factura de compra

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/stock.php';

/**
 * Registrar stock asociado a factura
 * POST stock.php/receipts
 * @param {Object} payload - { firebase_UID, id_purchase, receipt_date?, items: [{ id_item, quantity, unit_cost, discount_amount?, price?, id_pricing?, notes? }] }
 * price = precio final unitario con IVA: costo_unit * (1 + rate). El descuento es ganancia, no afecta el precio.
 */
export async function createStockReceipt(payload) {
  try {
    const res = await dotoniwoofApi.post(`${BASE}/receipts`, payload);
    const data = res.data;
    const status = data?.code ?? res.status;
    return { ok: true, status, data };
  } catch (error) {
    console.error('createStockReceipt error', error);
    const status = error.response?.status || 500;
    const data = error.response?.data || { message: 'Error de red o inesperado' };
    return { ok: false, status, data };
  }
}
